export default __webpack_public_path__ + "static/media/01-holding-money.b40ca72e.svg";